const ACTION_TYPE = "AFFILIATES";

export const GET_AFFILIATE_VOUCHERS = `${ACTION_TYPE}/GET_AFFILIATE_VOUCHERS`;
export const GET_AFFILIATE_USERS = `${ACTION_TYPE}/GET_AFFILIATE_USERS`;

export const UPDATE_VOUCHER = `${ACTION_TYPE}/UPDATE_VOUCHER`;

export const GENERATE_VOUCHER_QR_FAIL = `${ACTION_TYPE}/GENERATE_VOUCHER_QR_FAIL`;
export const GENERATE_VOUCHER_QR_SUCCESS = `${ACTION_TYPE}/GENERATE_VOUCHER_QR_SUCCESS`;
